import { Box } from '@mui/material';
import React from 'react';

import { Divider } from '../Divider/Divider';
import { FinalGridItem, FinalGridItemProps } from '../FinalGrid/FinalGrid';

type CategoryLinkListProps = Omit<FinalGridItemProps, 'xs' | 'sm' | 'md' | 'lg'> & {
  xs?: FinalGridItemProps['xs'];
  sm?: FinalGridItemProps['sm'];
  md?: FinalGridItemProps['md'];
  lg?: FinalGridItemProps['lg'];

  startDivider?: boolean;
  endDivider?: boolean;
  component?: 'ul' | 'div';
};

/**
 * CategoryLinkList is available for grouping link (e.g. CategoryLink, ProductLink, QuizButton)
 *
 * @param children
 * @param props
 * @constructor
 */
export const CategoryLinkList = React.forwardRef<HTMLDivElement, CategoryLinkListProps>(
  (
    { children, xs = 12, sm = 12, md = 12, lg = 12, startDivider = false, endDivider = true, component = 'div' },
    ref
  ) => {
    return (
      <FinalGridItem component={component} xs={xs} sm={sm} md={md} lg={lg} margin={0} width="100%" ref={ref}>
        {React.Children.toArray(children)
          .filter(Boolean) // filter out 'null' to prevent 'index' from breaking
          .map((child, index) => {
            return React.isValidElement(child) ? (
              <React.Fragment key={child.key}>
                {index !== 0 || startDivider ? (
                  <Box
                    component="li"
                    sx={{
                      listStyle: 'none',
                    }}
                    aria-hidden={true}
                  >
                    <Divider />
                  </Box>
                ) : null}
                {child}
              </React.Fragment>
            ) : null;
          })}
        {endDivider ? (
          <Box
            component="li"
            sx={{
              listStyle: 'none',
            }}
            aria-hidden={true}
          >
            <Divider />
          </Box>
        ) : null}
      </FinalGridItem>
    );
  }
);

CategoryLinkList.displayName = 'CategoryLinkList';
